export function degreesToRadians(angle) {
  return (angle * Math.PI) / 180;
}

export function radiansToDegrees(angle) {
  return (angle * 180) / Math.PI;
}
